export default {
  init() {
    $(window).on('load resize', function () {
      if ($(window).width() < 1025) { // mobile
        $('.checkout-sidebar').insertAfter('.woocommerce-shipping-fields');
      } else { // desktop
        $('.checkout-sidebar').insertBefore('.js-checkout-sidebar-desktop');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js